import React, { useState, useEffect } from 'react';
import { ShoppingBag, MapPin, CheckCircle } from 'lucide-react';

const names = [
  'Sarah M.', 'John D.', 'Emma W.', 'Michael R.', 'Lisa T.', 
  'David K.', 'Jennifer L.', 'Robert P.', 'Amanda S.', 'Chris B.',
  'Maria G.', 'James H.', 'Nicole F.', 'Kevin M.', 'Ashley C.'
];

const locations = [
  'New York, NY', 'Los Angeles, CA', 'Chicago, IL', 'Houston, TX',
  'Phoenix, AZ', 'Philadelphia, PA', 'San Diego, CA', 'Dallas, TX',
  'Miami, FL', 'Boston, MA', 'Seattle, WA', 'Denver, CO'
];

const products = [
  'Vitamin D3 5000IU', 'Omega-3 Fish Oil', 'Biotin Capsules',
  'Zinc Supplements', 'Magnesium Complex', 'Retinol Serum',
  'Hyaluronic Acid', 'Collagen Peptides', 'Probiotics',
  'Multivitamin Pack', 'CoQ10 Softgels', 'Iron Supplements'
];

const LivePurchaseNotification = () => {
  const [notification, setNotification] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const showNotification = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomLocation = locations[Math.floor(Math.random() * locations.length)];
      const randomProduct = products[Math.floor(Math.random() * products.length)];
      const randomTime = Math.floor(Math.random() * 10) + 1;

      setNotification({
        name: randomName,
        location: randomLocation,
        product: randomProduct,
        time: randomTime,
      });
      setIsVisible(true);

      // Hide after 4 seconds
      setTimeout(() => setIsVisible(false), 4000);
    };

    // Show first notification after 5 seconds
    const initialTimeout = setTimeout(showNotification, 5000);

    // Then show every 15-25 seconds
    const interval = setInterval(() => {
      showNotification();
    }, Math.random() * 10000 + 15000);

    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);

  if (!notification) return null;

  return (
    <div
      className={`fixed bottom-24 left-6 z-50 transition-all duration-500 transform ${
        isVisible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'
      }`}
      role="status"
      aria-live="polite"
    >
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl border border-gray-100 dark:border-gray-700 p-4 max-w-xs">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-full flex items-center justify-center flex-shrink-0">
            <ShoppingBag className="w-5 h-5 text-white" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-1 mb-1">
              <CheckCircle className="w-4 h-4 text-emerald-500" />
              <span className="text-sm font-semibold text-gray-800 dark:text-white">
                {notification.name}
              </span>
            </div>
            <p className="text-sm text-gray-600 dark:text-gray-300 truncate">
              purchased <span className="font-medium text-teal-600 dark:text-teal-400">{notification.product}</span>
            </p>
            <div className="flex items-center gap-1 mt-1 text-xs text-gray-500 dark:text-gray-400">
              <MapPin className="w-3 h-3" />
              <span>{notification.location}</span>
              <span>•</span>
              <span>{notification.time} min ago</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LivePurchaseNotification;
